import getPortalFacetFilter from '@/utils/PortalFacetFilter';
import { DataStorage } from '@studyportals/data-storage';
import { BaseSuperAgentRequestFactory, RequestSender } from '@studyportals/mb-platform-http-requests/base';
import { FacetValues, ProgrammeSearchFilters, ProgrammeSearchInput, SearchApiProgrammeClient, FacetFilterType } from '@studyportals/search-api-interface';

declare const SEARCH_API_URL: string;

const DISCIPLINES_FACET_VALUES_STORAGE_KEY = 'disciplines_facet_values';

export default class DisciplineFacetsRepository {
	private readonly searchApiProgrammeClient: SearchApiProgrammeClient;
	private readonly baseSuperAgentRequestFactory: BaseSuperAgentRequestFactory;
	private readonly requestSender: RequestSender;

	constructor() {
		this.baseSuperAgentRequestFactory = new BaseSuperAgentRequestFactory();
		this.requestSender = new RequestSender();
		this.searchApiProgrammeClient = new SearchApiProgrammeClient(SEARCH_API_URL, this.baseSuperAgentRequestFactory, this.requestSender);
	}

	public async getDisciplineFacets(): Promise<FacetValues[]> {
		if (this.areDisciplineFacetsCached) {
			return JSON.parse(DataStorage.retrieve(DISCIPLINES_FACET_VALUES_STORAGE_KEY) as string) as FacetValues[];
		}

		const portalFilter: ProgrammeSearchInput = getPortalFacetFilter();

		const result = await this.searchApiProgrammeClient.searchCards(
			new ProgrammeSearchFilters().from({
				...portalFilter,
				facets: [FacetFilterType.DISCIPLINES]
			}),
			0,
			0
		);

		if (result.facets) {
			const values = result.facets.map((f) => f.values).flat();
			DataStorage.store(DISCIPLINES_FACET_VALUES_STORAGE_KEY, JSON.stringify(values));
			return values;
		}

		return [];
	}

	public get areDisciplineFacetsCached(): boolean {
		const retrievedData = DataStorage.retrieve(DISCIPLINES_FACET_VALUES_STORAGE_KEY) as string | null;
		return !!retrievedData && retrievedData.length > 0;
	}
}